


import {CalendarSlotVM} from './CalendarSlotVM'; 
import {ProfessionalBookingCriteria} from './ProfessionalBookingCriteria'; 
export class CalendarVM {
    
    mbNumber?: string;
    
    monDate?: Date;
    
    tueDate?: Date;
    
    wedDate?: Date;
    
    thuDate?: Date;
    
    friDate?: Date;
    
    satDate?: Date;
    
    sunDate?: Date;
    
    mon?: CalendarSlotVM[];
    
    tue?: CalendarSlotVM[];
    
    wed?: CalendarSlotVM[];
    
    thu?: CalendarSlotVM[];
    
    fri?: CalendarSlotVM[];
    
    sat?: CalendarSlotVM[];
    
    sun?: CalendarSlotVM[];
    
    bookingCriteria?: ProfessionalBookingCriteria;
    
}
